import PropTypes from "prop-types";
import { ActivitiesFilter } from "./trainee.classroom.prog.filter";
import { ActivitiesSearchbox } from "./trainee.classroom.prog.searchbox";

export const ActivitiesToolbar = ({
  onOptionSelected,
  selected,
  activityOptions,
  data,
  onSearchTermChange,
  filters,
}) => {
  return (
    <>
      <ActivitiesFilter
        onOptionSelected={onOptionSelected}
        selected={selected}
        activityOptions={activityOptions}
      />
      <ActivitiesSearchbox
        data={data}
        onSearchTermChange={onSearchTermChange}
        filters={filters}
      />
    </>
  );
};

ActivitiesToolbar.propTypes = {
  onOptionSelected: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  activityOptions: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onSearchTermChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
};
